/*
 * Copyright (c) 2022 EGT Digital - All rights reserved.
 *
 * File: Category.tsx
 *
 * Written by Martin Lubenov <martin.lubenov@egt-digital.com> on  01.11.22 11:08 am.
 * Last modified: 01.11.22 11:08 am.
 *
 * More information at: https://egt-digital.com/
 */
import React from 'react';
import CustomIconImg from '../components/CustomIconImg';
import { useLobbyHost, useSelectedSection } from '../contexts/SettingsContext';
import { useTranslator } from '../contexts/TranslatorContext';

const Category = ({ name, isSelected }: ICategoryProps) => {
    const [, setSelectedSection] = useSelectedSection();
    const host = useLobbyHost();
    const translate = useTranslator();

    const handleClick = () => {
        setSelectedSection(name);
    };

    return (
        <div
            className={`egtd_lobby_item egtd_lobby_item_${name.toLowerCase()} ${
                isSelected ? 'egtd_lobby_item_active' : ''
            }`}
            onClick={handleClick}
        >
            <CustomIconImg name={name} host={host} />
            <span className="name">
                <span>{translate(`${name.toUpperCase()}_TAB`)}</span>
            </span>
        </div>
    );
};

interface ICategoryProps {
    name: string;
    isSelected: boolean;
}

export default Category;
